import { makeStyles } from '@material-ui/core/styles';

export const LocationCardStyles =
makeStyles((theme) => ({
    locationCard: {
        display: "block",
        //[theme.breakpoints.only("md")]: {
        //    height: "150px",
        //},
    },

    locationCardDetails: {
        display: 'flex',
        flexGrow: 1,
        flexBasis: 0,
        flexDirection: 'column',
        backgroundColor: theme.palette.background.paper,
    },

    locationCardContent: {
        flex: '1 0 auto',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },

    locationCardCover: {
        //width: 80,
        //padding: 20,
        //margin: "auto",
    },

    locationCardCoverImg: {
        margin: "auto",
        marginTop: "5px",
    },

    locationCardControls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },

    locationCardControlButton: {
        paddingTop: 0,
        paddingBottom: 0,
        verticalAlign: "top"
    },
}));
